import { Box, Paper, Typography } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useTranslation } from "react-i18next";

export const filterFieldSx = {
  "& .MuiInputBase-root": {
    height: 32,
    borderRadius: "6px",
    backgroundColor: "background.paper",
  },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "divider" },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "text.secondary" },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "primary.main",
    borderWidth: "1px",
  },
  "& .MuiInputBase-input, & .MuiSelect-select": {
    fontSize: 12,
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingLeft: "12px",
  },
  "& .MuiInputLabel-root": { fontSize: 11, color: "text.secondary" },
};

export default function AdminFilterPanel({ children }) {
  const { t } = useTranslation();
  return (
    <Paper
      sx={{
        mb: 2,
        borderRadius: "14px",
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "0 4px 14px rgba(15, 23, 42, 0.05)",
        overflow: "hidden",
        backgroundColor: "background.paper",
      }}
    >
      <Box
        sx={{
          height: 42,
          px: "18px",
          display: "flex",
          alignItems: "center",
          gap: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <FilterListIcon sx={{ fontSize: 18, color: "primary.main" }} />
        <Typography sx={{ fontWeight: 700, fontSize: 13, color: "text.primary" }}>{t("admin.filter.filtros")}</Typography>
      </Box>

      <Box sx={{ p: "14px 18px 16px 18px", display: "flex", gap: "14px", flexWrap: "wrap", alignItems: "flex-end" }}>
        {children}
      </Box>
    </Paper>
  );
}
